/* eslint-disable func-names */
const toggles = Array.from( document.querySelectorAll( '[data-toggle]' ) );
const contents = Array.from( document.querySelectorAll( '[data-toggle-content]' ) );

/**
 * Get all siblings of an element
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}  elem The element
 * @return {Array}      The siblings
 */
const getSiblings = function ( elem ) {
	return Array.prototype.filter.call( elem.parentNode.children, function ( sibling ) {
		return sibling !== elem;
	} );
};

/**
 * Closes a toggle node pair.
 *
 * @param {Object} content The content node.
 */
function close( content ) {
	const toggles = Array.from( document.querySelectorAll(
		`[data-toggle="${content.getAttribute( 'data-toggle-content' )}"]`
	) );

	if ( ! toggles.length ) {
		return;
	}

	toggles.forEach( toggle => {
		toggle.setAttribute( 'aria-expanded', false );
		toggle.setAttribute( 'data-open', false );
	} );

	content.setAttribute( 'aria-hidden', true );
	content.setAttribute( 'data-open', false );
}

/**
 * Opens a toggle node pair.
 *
 * @param {Object} content The content node.
 * @param {Object} toggle The toggle node.
 */
function open( content, toggle = false ) {

	if ( toggle ) {
		// Close all subling toggle/content pairs.
		const siblingContents = getSiblings( toggle );
		siblingContents.forEach( ( siblingContent ) => {
			close( siblingContent );
		} );
	}

	const toggles = content && Array.from( document.querySelectorAll(
		`[data-toggle="${content.getAttribute( 'data-toggle-content' )}"]`
	) );

	if ( ! toggles || ! toggles.length ) {
		return;
	}

	// Open this one.
	toggles.forEach( toggle => {
		toggle.setAttribute( 'aria-expanded', true );
		toggle.setAttribute( 'data-open', true );
	} );
	content.setAttribute( 'aria-hidden', false );
	content.setAttribute( 'data-open', true );
}

/**
 * Handle toggle clicks.
 *
 * @param {Object} event The event object.
 */
const handleToggleClick = ( event ) => {
	const { target: toggle } = event;
	const content = document.querySelector(
		`[data-toggle-content="${toggle.getAttribute( 'data-toggle' )}"]`,
	);
	const isOpen = 'true' === content && content.getAttribute( 'data-open' );

	event.stopPropagation();

	if ( isOpen ) {
		close( content );
	} else {
		open( content, toggle );
	}
};

/**
 * Handle content keydown.
 *
 * @param {Object} event The event object.
 */
const handleContentKeydown = ( event ) => {
	const { target, keyCode, shiftKey } = event;
	const content = target.closest( '[data-toggle-content]' );
	const toggle = document.querySelector(
		`[data-toggle="${content.getAttribute( 'data-toggle-content' )}"]`,
	);

	// Escape.
	if ( 27 === keyCode ) {
		close( content );
		toggle.focus();
	}

	// Bail if not tab.
	if ( 9 !== keyCode ) {
		return;
	}

	// Handle tabbing.
	const focusable = Array.from( content.querySelectorAll( 'a, button' ) );
	const [first] = focusable;
	const last = focusable[focusable.length - 1];

	if ( target === last && !shiftKey ) {
		close( content );
	}

	if ( target === first && shiftKey ) {
		close( content );
	}
};

/**
 *
 * @param {Object} content The content node.
 */
const setupBreakpoint = ( content ) => {
	const config = content.getAttribute( 'data-config' );

	if ( !config ) {
		return;
	}

	const { breakpoint } = JSON.parse( config );
	const mq = window.matchMedia( `(min-width: ${breakpoint}px)` );

	/**
	 * Handle on change.
	 */
	const onChange = () => {
		if ( mq.matches ) {
			open( content );
		}
	};

	mq.addEventListener( 'change', onChange );
	onChange();
};

/**
 * Init
 */
const init = () => {
	toggles.forEach( ( toggle ) => {
		toggle.setAttribute( 'aria-expanded', false );
		toggle.setAttribute( 'data-open', false );

		toggle.addEventListener( 'click', handleToggleClick );
	} );

	contents.forEach( ( content ) => {
		content.setAttribute( 'aria-hidden', true );
		content.setAttribute( 'data-open', false );

		content.addEventListener( 'click', ( event ) => {
			event.stopPropagation();
		} );
		content.addEventListener( 'keydown', handleContentKeydown );

		setupBreakpoint( content );
	} );
};

export default init;
